import { render, staticRenderFns } from "./takipno.vue?vue&type=template&id=ed70ad20&"
import script from "./takipno.vue?vue&type=script&lang=js&"
export * from "./takipno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports